import { render } from "./ContactBody.vue?vue&type=template&id=2eacad70"
import script from "./ContactBody.vue?vue&type=script&lang=js"
export * from "./ContactBody.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__